import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Spinner } from '@chakra-ui/react';
import { useMe } from '../lib/MeContext';

type Role = 'admin' | 'asistente';

export function RequireRole({ allow, children }: { allow: Role[]; children: ReactNode }) {
  const { me, loading } = useMe();
  if (loading) {
    return (
      <Box minH="50vh" display="flex" alignItems="center" justifyContent="center">
        <Spinner />
      </Box>
    );
  }
  if (!me || !allow.includes(me.role)) {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
